import { type ComponentType } from "react"
import { withAuthenticationRequired } from "@auth0/auth0-react"
import { MainLoader } from "@components/MainLoader"

export function AuthenticationGuard({
  component,
}: {
  component: ComponentType
}) {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <MainLoader />,
  })
  return <Component />
}
